import { FunctionComponent, useEffect, useRef } from 'react'
import useAds from '@hooks/useAds'
import { logAdMessage } from '@utils/ads'

const LoadAdsSection: FunctionComponent = () => {
  const { loadAllSlots, updateAreAdSlotsLoaded } = useAds()
  const timeoutRef = useRef<number>()

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = window.setTimeout(() => {
      logAdMessage(`ADS: LoadAdsSection mounted!`)
      updateAreAdSlotsLoaded(true)
      loadAllSlots()
    }, 0)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [loadAllSlots, updateAreAdSlotsLoaded])

  return null
}

export default LoadAdsSection
